<template>
  <v-dialog v-model="dialogOpen" width="400" persistent>

    <v-card v-if="showCreateForLink">
      <v-card-title>Create "Change of {{nameMap[type]}}" Lead</v-card-title>

      <v-card-text>
        Are you sure? This will create a new lead linked to this one with the source "{{type}}"
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="getIsCreateLinkedProductLoading" :loading="getIsCreateLinkedProductLoading">CREATE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getIsCreateLinkedProductLoading">CANCEL</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-else>
      <v-card-title>Success!</v-card-title>

      <v-card-text>
        Linked product <a :href="`/products/${getLinkedTypeProduct.product_2_id}`">{{getLinkedTypeProduct.product_2_id}}</a> has been created!
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn color="primary" small outlined @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";

  export default {
    props: ['dialogOpen','type'],

    data() {
      return {
        nameMap: {
          COT: 'Tenancy',
          COP: 'Premises',
        }
      }
    },

    computed: {
      ...mapState('products', ['currentProduct']),
      ...mapGetters('productLinks', ['getLinkedProductByType', 'getIsCreateLinkedProductLoading','getLinkedProducts']),

      linkedID() {
        return (this.getLinkedProductByType(this.type).product_2_id!==undefined)?this.getLinkedProductByType(this.type).product_2_id:false;
      },

      getLinkedTypeProduct() {
        return this.getLinkedProductByType(this.type);
      },

      showCreateForLink(){
        const links = this.getLinkedProducts.filter(e=>e.link_type===this.type && this.currentProduct.id === e.product_1_id);
        return links.length === 0;
      },
    },

    methods: {
      ...mapActions('productLinks', ['createLinkedProduct']),

      async submit() {
        await this.createLinkedProduct({ lead_id: this.currentProduct.id, payload: { link_type: this.type } });
      },

      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
